/**
 * Client-side backup-code generation. The code encodes the anonymous player
 * UUID in Crockford base32 (matching functions/_lib/backup.ts), so a backup
 * code can be produced locally from the stored player id without a live server
 * round-trip. (Import still needs the server to fetch the saved progress.)
 */

const ALPHABET = "0123456789ABCDEFGHJKMNPQRSTVWXYZ"; // Crockford base32 (no I L O U)

function bytesToBase32(bytes: Uint8Array): string {
  let bits = 0;
  let value = 0;
  let out = "";
  for (const b of bytes) {
    value = (value << 8) | b;
    bits += 8;
    while (bits >= 5) {
      out += ALPHABET[(value >>> (bits - 5)) & 31];
      bits -= 5;
    }
  }
  if (bits > 0) out += ALPHABET[(value << (5 - bits)) & 31];
  return out;
}

function uuidToBytes(uuid: string): Uint8Array {
  const hex = uuid.replace(/-/g, "");
  const bytes = new Uint8Array(16);
  for (let i = 0; i < 16; i++) bytes[i] = parseInt(hex.slice(i * 2, i * 2 + 2), 16);
  return bytes;
}

/** Build a grouped backup code from a player UUID. */
export function backupCode(playerId: string): string {
  const code = bytesToBase32(uuidToBytes(playerId));
  return (code.match(/.{1,4}/g) ?? [code]).join("-");
}
